import type { CellRendererContext } from "echart-table-library";

/**
 * Business callback: pill badge per machine status (FR-L9 style).
 * Business code — belongs to the app, never the library (D4).
 */
const TONES: Record<string, string> = {
  ok: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  warning: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  error: "bg-red-500/15 text-red-600 dark:text-red-400",
};

export function renderStatusCell({
  value,
}: CellRendererContext): HTMLElement {
  const status = String(value ?? "");
  const span = document.createElement("span");
  span.textContent = status.toUpperCase();
  span.className = `inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
    TONES[status.toLowerCase()] ?? "bg-muted text-muted-foreground"
  }`;
  return span;
}
